import React, { useContext } from 'react'
import { currentActiveThreadChatbotThreadData } from '../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { extractFileNameFromUrl, getMediaUrl } from '../../../utils';
import { renderMediaMsg } from '../../../renderUtils';

interface UserMediaMessagesProps {
    thread: currentActiveThreadChatbotThreadData,
}  

const UserMediaMessages: React.FC<UserMediaMessagesProps> = (props) => {
    
    const { thread } = props;
    const { vendorData } = useContext(UserContext) as UserContextPayload;

    const getMediaMessageUrl = (thread: currentActiveThreadChatbotThreadData) => {
        const storageId = thread?.action_execution_data?.google_storage_id ?? "";
        return getMediaUrl(vendorData, storageId) ?? '';
    }

    const getMediaDetails = () => {
        const data = thread?.action_execution_data;
        return {
            fileType: data?.file_type ?? "",
            caption: data?.caption ?? "",
            fileName: extractFileNameFromUrl(data?.file_name ?? '') ?? ""
        }
    }

    return (
        <>
            {renderMediaMsg(getMediaDetails()?.fileType, getMediaMessageUrl(thread), getMediaDetails()?.caption, getMediaDetails()?.fileName)}
        </>
    )
}

export default UserMediaMessages
